import { useSessionStore } from '@/stores/SessionStore'
import { useUserStore } from '@/stores/UserStore';
import { useApiData } from '@/composables/useApiData';

export const useApiForecastModels = () => {
  const userStore = useUserStore();
  const sessionStore = useSessionStore();
  const apiAlertData = useApiData('model');

  async function getAvailableModelsByArea(bounds, settings) {
    if (!bounds) {
      console.warn('Bounds required for endpoint getAvailableModelsByArea')
      return
    }

    const { latMin, lonMin, latMax, lonMax } = bounds

    const defaultSettings = {
      min_lat: latMin,
      max_lat: latMax,
      min_lon: lonMin,
      max_lon: lonMax,
    }

    const params = Object.assign(defaultSettings, settings);

    return await apiAlertData.request('getAvailableModelsByArea', params);
  }

  async function getAvailableModelsByLatLon(lat, lon, settings) {
    if (!lat || !lon) {
      console.warn('Bounds required for endpoint getAvailableModelsByArea')
      return
    }

    const defaultSettings = {
      lat: lat,
      lon: lon,
    }

    const params = Object.assign(defaultSettings, settings);

    return await apiAlertData.request('getAvailableModelsByLatLon', params);
  }

  async function getAvailableModelsBySpot({ spotId = null, favSpotId = null }, settings) {
    if (!spotId && !favSpotId) {
      console.warn('A spot or fav spot id is required for endpoint getAvailableModelsBySpot')
      return
    }

    const params = Object.assign({}, settings);
    if (spotId) params['spot_id'] = spotId;
    else if (favSpotId) params['fav_spot_id'] = favSpotId;

    return await apiAlertData.request('getAvailableModelsBySpot', params);
  }

  async function byArea(bounds, settings) {
    return await getAvailableModelsByArea(bounds, settings)
  }

  async function byLatLon(lat, lon, settings) {
    return await getAvailableModelsByLatLon(lat, lon, settings)
  }

  async function bySpot(idObject, settings) {
    return await getAvailableModelsBySpot(idObject, settings)
  }

  return {
    byArea,
    byLatLon,
    bySpot
  }
}
